<template>
  <div>
    <div class="grid">
      <figure class="effect-bubba blue">
        <img :src="story.image" :id="'story-image-' + story.id" @error="onImageLoadFailure($event, 'story-image-' + story.id)">
        <figcaption>
          <p>{{story.text1}}<br>
            <strong>{{story.text2}}</strong></p>
          <h2>{{storyDescTitle}}'ve {{story.textPP}}<br> <strong>{{story.totalBeneficiaries}}</strong> {{story.text3}}</h2>
          <a href="https://www.b1g1.com" target="_blank">Powered by B1G1</a>
        </figcaption>
      </figure>
    </div>
  </div>
</template>

<script>
import config from '../../../config/app'

export default {
  props: ['story', 'storyDescTitle'],
  data () {
    return {
      host: config.host,
      defaultStoryImage: '/static/logos/b1g1-none-img-400.png'
    }
  },
  methods: {
    onImageLoadFailure (event, id) {
      document.getElementById(id).src = this.defaultStoryImage
    }
  }
}
</script>

<style scoped>
.grid {
  font-family: 'Ubuntu', sans-serif;
  position: relative;
  margin: 0 auto;
  max-width: 1000px;
  list-style: none;
  text-align: center;
}

/* Common style */
.grid figure {
  position: relative;
  float: left;
  overflow: hidden;
  /* margin: 10px 1%;
  min-width: 320px;
  max-width: 480px;
  max-height: 360px;
  width: 48%;*/
  background: #3085a3;
  text-align: center;
  cursor: pointer;
}

.grid figure img {
  position: relative;
  display: block;
  min-height: 100%;
  max-width: 100%;
  opacity: 0.8;
}

.grid figure figcaption {
  /*padding: 2em;*/
  color: #fff;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before,
.grid figure figcaption::after {
  pointer-events: none;
}

.grid figure figcaption {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.grid figure h2{
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
}

.grid figure h2 strong{
  font-weight: 500 !important;
  font-size: 48px;
  line-height: 70px;
  display: block;
}

.grid figure h2 span {
  font-weight: 800;
}

.grid figure h2,
.grid figure p {
  margin: 0;
}

.grid figure p {
  letter-spacing: 1px;
  font-size: 18px;
  font-weight: 300;
  line-height: 30px;
}

.grid figure p strong {
  font-weight: 700;
}

/*---------------*/
/***** Bubba *****/
/*---------------*/

figure.effect-bubba {
  background: #9e5406;
}

figure.effect-bubba img {
  opacity: 0.6;
  -webkit-transition: opacity 0.35s;
  transition: opacity 0.35s;
}

figure.effect-bubba:hover img {
  opacity: 0.2;
}

figure.effect-bubba figcaption::before,
figure.effect-bubba figcaption::after {
  position: absolute;
  top: 30px;
  right: 30px;
  bottom: 30px;
  left: 30px;
  content: '';
  opacity: 0;
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
}

figure.effect-bubba figcaption::before {
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  -webkit-transform: scale(0, 1);
  transform: scale(0, 1);
}

figure.effect-bubba figcaption::after {
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  -webkit-transform: scale(1, 0);
  transform: scale(1, 0);
}

figure.effect-bubba h2 {
  padding: 20px 2.5em;
  opacity: 0;
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(0, 20px, 0);
  transform: translate3d(0, 20px, 0);
}

figure.effect-bubba p {
  /*padding-top: 48%;*/
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(0, -20px, 0);
  transform: translate3d(0, -20px, 0);
  padding-left: 30px;
  padding-right: 30px;
  top: 50%;
  position: relative;
  transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
}

figure.effect-bubba:hover figcaption::before,
figure.effect-bubba:hover figcaption::after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

figure.effect-bubba:hover h2, figure.effect-bubba:hover a {
  opacity: 1;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

figure.effect-bubba:hover p {
  opacity: 0;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.effect-bubba.blue, .effect-bubba.gray {
  background: #000;
}

.effect-bubba.blue:hover {
  background: #00B4EB;
}

.effect-bubba:hover {
  background: #363537;
}

.mkt {
  float: left;
}

.grid figure figcaption > a{
  opacity: 0;
  color: #fff;
  font-size: 12px;
  z-index: 400;
  position: absolute;
  bottom: 40px;
  left: 0px;
  right: 0px;

}

figure.effect-bubba h2{
  position: absolute !important;
  top: 50%;
  transform: translate(0, -50%) !important;
  right: 0px;
  left: 0px;
}
.grid figure figcaption a:hover{
  text-decoration: underline !important;
}
@media screen and (max-width: 481px) {

}
</style>



// WEBPACK FOOTER //
// src/components/widgets/StoryWidget/StoryWidgetWeb.vue